import { render, staticRenderFns } from "./Tokens.vue?vue&type=template&id=0fab3876&scoped=true"
import script from "./Tokens.vue?vue&type=script&setup=true&lang=js"
export * from "./Tokens.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Tokens.vue?vue&type=style&index=0&id=0fab3876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fab3876",
  null
  
)

export default component.exports